<template>
 <div style="height: 100%;">
   <page v-if="$route.path === '/plan/happy'">
     <ZuiHeader/>
     <SubPageTemplate page-title="玩的安逸" dynamically-tab wenqun-item sub-img list-title :pid="$cid.play.wanDeAnYi" :default-tab-id="tabId"
                      :page-size="5" type="article" :video-mask="false" @article-click="articleClick"></SubPageTemplate>
     <ZuiFooter/>
   </page>
   <router-view v-else></router-view>
 </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/plan/happy/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/plan/happy.vue